import React from 'react'
import R from 'ramda'
import styled from 'styled-components'

const Rect = styled.rect`
  fill: #aaa;
  fill-opacity: ${({ isSelected }) => (isSelected ? '.15' : '0')};
`
// stroke-opacity: ${({ isSelected }) => (isSelected ? '.2' : '0')};
// stroke: #333;

const MonthSelection = ({
  xScale,
  yScale,
  minValue,
  maxValue,
  recordDate,
  selectDate,
  hoverDate,
}) => {
  const ticks = xScale.ticks()
  const b = R.tail(ticks)
  const a = R.remove(ticks.length - 1, 1, ticks)
  const widths = R.zip(a, b)
  return widths.map(([x1, x2], i) => (
    <Rect
      key={`month${i}`}
      x={xScale(x1)}
      y={yScale(maxValue)}
      width={xScale(x2) - xScale(x1)}
      height={yScale(minValue) - yScale(maxValue)}
      isSelected={x1.getTime() < recordDate.getTime()}
      onClick={() => selectDate(x1)}
      onMouseEnter={() => hoverDate(x1)}
      onMouseLeave={() => hoverDate()}
    />
  ))
}

export default MonthSelection
